export const SCANS_ACCRPTED = '.stl'